import {
    ChatMessage,
    type ChatMessageProps,
    type ChatReaction,
} from "@albertine/design-system/components/chat";
import { useScrollableReply } from "../-hooks/useScrollableReply";

export function SentThreadMessage({
    message,
    onReply,
    onReact,
    onRemoveReaction,
    onCopy,
}: {
    message: ChatMessageProps;
    onReply: (messageText: string) => void;
    onReact: (reaction: ChatReaction) => void;
    onRemoveReaction: () => void;
    onCopy: () => void;
}) {
    const reply = useScrollableReply(message.reply);

    return (
        <ChatMessage
            {...message}
            reply={reply}
            onReply={onReply}
            onReact={onReact}
            onRemoveReaction={onRemoveReaction}
            onCopy={onCopy}
        />
    );
}

export function PendingThreadMessage({
    props,
    onRetrySend,
}: {
    props: ChatMessageProps;
    onRetrySend: () => void;
}) {
    const reply = useScrollableReply(props.reply);

    return <ChatMessage {...props} reply={reply} onRetrySend={onRetrySend} />;
}
